import { SVGIconProps } from './types'

export const BarChartIcon = (props: SVGIconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9777 13.482C14.9777 13.6143 14.9251 13.7413 14.8315 13.8349C14.7379 13.9285 14.6109 13.9811 14.4785 13.9811H2.49914C2.36676 13.9811 2.2398 13.9285 2.14619 13.8349C2.05259 13.7413 2 13.6143 2 13.482V3.49914C2 3.36676 2.05259 3.2398 2.14619 3.1462C2.2398 3.05259 2.36676 3 2.49914 3C2.63152 3 2.75848 3.05259 2.85209 3.1462C2.94569 3.2398 2.99828 3.36676 2.99828 3.49914V9.38713L6.16346 6.61877C6.24959 6.54337 6.35902 6.49987 6.4734 6.49556C6.58779 6.49124 6.70018 6.52637 6.79175 6.59506L10.4611 9.3472L14.1497 6.11963C14.1981 6.07175 14.2557 6.03427 14.3191 6.00949C14.3825 5.98471 14.4503 5.97315 14.5183 5.97553C14.5863 5.9779 14.6531 5.99416 14.7146 6.02329C14.7761 6.05243 14.831 6.09384 14.8759 6.14497C14.9208 6.1961 14.9548 6.25587 14.9757 6.32062C14.9967 6.38536 15.0042 6.45371 14.9978 6.52146C14.9914 6.5892 14.9711 6.65492 14.9384 6.71458C14.9056 6.77423 14.861 6.82656 14.8073 6.86834L10.8142 10.3623C10.7281 10.4377 10.6186 10.4812 10.5043 10.4855C10.3899 10.4899 10.2775 10.4547 10.1859 10.386L6.5166 7.63515L2.99828 10.7136V12.9828H14.4785C14.6109 12.9828 14.7379 13.0354 14.8315 13.129C14.9251 13.2226 14.9777 13.3496 14.9777 13.482Z"
      fill="currentColor"
    />
  </svg>
)
